var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c("div", [
        _c("div", [
          _c("article", { staticClass: "box" }, [
            _c("div", { staticClass: "columns is-gapless" }, [
              _c(
                "div",
                { staticClass: "column" },
                [
                  _c("div", { staticClass: "columns is-gapless" }, [
                    _c("div", { staticClass: "column" }, [
                      _c("p", { staticClass: "title" }, [
                        _vm._v(" Authorise Items "),
                      ]),
                      _vm.isEditableToAuthorise
                        ? _c("p", { staticClass: "subtitle" }, [
                            _c("span", [
                              _c(
                                "span",
                                { staticClass: "has-text-weight-semibold" },
                                [_vm._v(" Target Value: ")]
                              ),
                              _c(
                                "span",
                                {
                                  staticClass:
                                    "has-text-success has-text-weight-semibold",
                                },
                                [
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        _vm.$filters.formatCurrency(
                                          _vm.targetValue,
                                          _vm.$userInfo.locale
                                        )
                                      ) +
                                      " "
                                  ),
                                ]
                              ),
                            ]),
                            _c("span", { staticClass: "ml-6" }, [
                              _c(
                                "span",
                                { staticClass: "has-text-weight-semibold" },
                                [_vm._v(" Value To Be Authorise: ")]
                              ),
                              _c(
                                "span",
                                {
                                  staticClass: "has-text-weight-semibold",
                                  class: _vm.targetValueColor,
                                },
                                [
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        _vm.$filters.formatCurrency(
                                          _vm.totalSelectedItems,
                                          _vm.$userInfo.locale
                                        )
                                      ) +
                                      " "
                                  ),
                                ]
                              ),
                            ]),
                          ])
                        : _vm._e(),
                      _vm.isEditable
                        ? _c("div", [
                            _c(
                              "div",
                              {
                                staticClass:
                                  "pretty p-icon p-curve p-smooth m-0 p-bigger",
                              },
                              [
                                _c("input", {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: _vm.allItemSelected,
                                      expression: "allItemSelected",
                                    },
                                  ],
                                  attrs: { type: "checkbox" },
                                  domProps: {
                                    checked: Array.isArray(_vm.allItemSelected)
                                      ? _vm._i(_vm.allItemSelected, null) > -1
                                      : _vm.allItemSelected,
                                  },
                                  on: {
                                    change: function ($event) {
                                      var $$a = _vm.allItemSelected,
                                        $$el = $event.target,
                                        $$c = $$el.checked ? true : false
                                      if (Array.isArray($$a)) {
                                        var $$v = null,
                                          $$i = _vm._i($$a, $$v)
                                        if ($$el.checked) {
                                          $$i < 0 &&
                                            (_vm.allItemSelected = $$a.concat([
                                              $$v,
                                            ]))
                                        } else {
                                          $$i > -1 &&
                                            (_vm.allItemSelected = $$a
                                              .slice(0, $$i)
                                              .concat($$a.slice($$i + 1)))
                                        }
                                      } else {
                                        _vm.allItemSelected = $$c
                                      }
                                    },
                                  },
                                }),
                                _vm._m(0),
                              ]
                            ),
                            !_vm.allItemSelected && _vm.isEditableToAuthorise
                              ? _c(
                                  "p",
                                  { staticClass: "has-text-danger is-size-7" },
                                  [
                                    _vm._v(
                                      " Please select all items for authorise. "
                                    ),
                                  ]
                                )
                              : _vm._e(),
                          ])
                        : _vm._e(),
                    ]),
                    _c("div", { staticClass: "column" }, [
                      _c("div", { staticClass: "control is-pulled-right" }, [
                        _c("div", { staticClass: "field-body" }, [
                          _c("div", { staticClass: "field mr-2" }, [
                            _c("div", { staticClass: "buttons" }, [
                              _vm.hasAssessment &&
                              !_vm.isEditable &&
                              _vm.requestAuthorityPending
                                ? _c(
                                    "button",
                                    {
                                      staticClass:
                                        "button is-secondary tooltip is-tooltip-topright",
                                      attrs: {
                                        "data-tooltip":
                                          "Cancel the last request to authority",
                                      },
                                      on: {
                                        click: function ($event) {
                                          return _vm.openCancelRequestConfirmModal()
                                        },
                                      },
                                    },
                                    [
                                      _vm._m(1),
                                      _c("span", [_vm._v("Cancel Request")]),
                                    ]
                                  )
                                : _vm._e(),
                              _vm.hasAssessment &&
                              !_vm.isEditable &&
                              !_vm.requestAuthorityPending
                                ? _c(
                                    "button",
                                    {
                                      staticClass:
                                        "button is-secondary tooltip is-tooltip-topright",
                                      attrs: {
                                        "data-tooltip":
                                          "Cancel the last authority",
                                      },
                                      on: {
                                        click: function ($event) {
                                          return _vm.openCancelAuthorityConfirmModal()
                                        },
                                      },
                                    },
                                    [
                                      _vm._m(2),
                                      _c("span", [_vm._v("Cancel Authority")]),
                                    ]
                                  )
                                : _vm._e(),
                              _vm.hasAssessment &&
                              !_vm.isEditable &&
                              !_vm.requestAuthorityPending &&
                              _vm.allActiveItems.length > 0
                                ? _c(
                                    "button",
                                    {
                                      staticClass:
                                        "button is-secondary tooltip is-tooltip-topright",
                                      attrs: {
                                        "data-tooltip":
                                          "Revert to last authority",
                                      },
                                      on: {
                                        click: function ($event) {
                                          return _vm.openRevertConfirmModal()
                                        },
                                      },
                                    },
                                    [
                                      _vm._m(3),
                                      _c("span", [
                                        _vm._v("Revert to Authority"),
                                      ]),
                                    ]
                                  )
                                : _vm._e(),
                              _vm.isEditable
                                ? _c(
                                    "button",
                                    {
                                      staticClass:
                                        "button is-secondary tooltip is-tooltip-topright",
                                      attrs: { "data-tooltip": "Cancel" },
                                      on: {
                                        click: function ($event) {
                                          return _vm.cancel()
                                        },
                                      },
                                    },
                                    [_vm._m(4), _c("span", [_vm._v("Cancel")])]
                                  )
                                : _vm._e(),
                              !_vm.isEditable &&
                              !_vm.requestAuthorityPending &&
                              _vm.allActiveItems.length > 0
                                ? _c(
                                    "button",
                                    {
                                      staticClass:
                                        "button is-info is-outlined tooltip is-tooltip-topright",
                                      attrs: {
                                        "data-tooltip": "Submit request",
                                      },
                                      on: {
                                        click: function ($event) {
                                          return _vm.editableQuote(false)
                                        },
                                      },
                                    },
                                    [
                                      _vm._m(5),
                                      _c("span", [_vm._v("Request Authority")]),
                                    ]
                                  )
                                : _vm._e(),
                              !_vm.isEditable
                                ? _c(
                                    "button",
                                    {
                                      staticClass:
                                        "button is-info is-outlined tooltip is-tooltip-topright",
                                      attrs: {
                                        "data-tooltip": "Submit authorise",
                                      },
                                      on: {
                                        click: function ($event) {
                                          return _vm.editableQuote(true)
                                        },
                                      },
                                    },
                                    [
                                      _vm._m(6),
                                      _c("span", [_vm._v("Authorise")]),
                                    ]
                                  )
                                : _vm._e(),
                              _vm.isEditable && _vm.isEditableToAuthorise
                                ? _c(
                                    "button",
                                    {
                                      staticClass:
                                        "button is-success tooltip is-tooltip-topright",
                                      attrs: {
                                        disabled:
                                          (_vm.allItemSelected === false &&
                                            _vm.hasPendingRequest) ||
                                          _vm.selectedItems.length === 0,
                                        "data-tooltip":
                                          "Autorise selected items",
                                      },
                                      on: {
                                        click: function ($event) {
                                          return _vm.openAuthoriseModal()
                                        },
                                      },
                                    },
                                    [
                                      _vm._m(7),
                                      _c("span", [_vm._v("Confirm Authorise")]),
                                    ]
                                  )
                                : _vm._e(),
                              _vm.isEditable && !_vm.isEditableToAuthorise
                                ? _c(
                                    "button",
                                    {
                                      staticClass:
                                        "button is-success tooltip is-tooltip-topright",
                                      attrs: {
                                        disabled:
                                          _vm.selectedItems.length === 0,
                                        "data-tooltip":
                                          "Request selected items",
                                      },
                                      on: { click: _vm.request },
                                    },
                                    [
                                      _vm._m(8),
                                      _c("span", [
                                        _vm._v("Confirm Request Authority"),
                                      ]),
                                    ]
                                  )
                                : _vm._e(),
                            ]),
                          ]),
                        ]),
                      ]),
                    ]),
                  ]),
                  _c("div", { staticClass: "tabs is-boxed" }, [
                    _c("ul", [
                      _c(
                        "li",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: _vm.showTab("RR"),
                              expression: "showTab('RR')",
                            },
                          ],
                          class: {
                            "is-active":
                              _vm.activeTab === _vm.itemCategoryTypes.RR,
                          },
                        },
                        [
                          _c(
                            "a",
                            {
                              on: {
                                click: function ($event) {
                                  return _vm.tabClicked(
                                    _vm.itemCategoryTypes.RR
                                  )
                                },
                              },
                            },
                            [
                              _c("span", [
                                _c(
                                  "span",
                                  { staticClass: "has-badge-child-offset2" },
                                  [_vm._v("R&R")]
                                ),
                                _vm.rrItems.length > 0
                                  ? _c("span", {
                                      staticClass:
                                        "has-badge-rounded has-badge-medium has-badge-info",
                                      attrs: {
                                        "data-badge": _vm.rrItems.length,
                                      },
                                    })
                                  : _vm._e(),
                              ]),
                            ]
                          ),
                        ]
                      ),
                      _c(
                        "li",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: _vm.showTab("RWA"),
                              expression: "showTab('RWA')",
                            },
                          ],
                          class: {
                            "is-active":
                              _vm.activeTab === _vm.itemCategoryTypes.RWA,
                          },
                        },
                        [
                          _c(
                            "a",
                            {
                              on: {
                                click: function ($event) {
                                  return _vm.tabClicked(
                                    _vm.itemCategoryTypes.RWA
                                  )
                                },
                              },
                            },
                            [
                              _c("span", [
                                _c(
                                  "span",
                                  { staticClass: "has-badge-child-offset2" },
                                  [_vm._v("RWA")]
                                ),
                                _vm.rwaItems.length > 0
                                  ? _c("span", {
                                      staticClass:
                                        "has-badge-rounded has-badge-medium has-badge-info",
                                      attrs: {
                                        "data-badge": _vm.rwaItems.length,
                                      },
                                    })
                                  : _vm._e(),
                              ]),
                            ]
                          ),
                        ]
                      ),
                      _c(
                        "li",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: _vm.showTab("REP"),
                              expression: "showTab('REP')",
                            },
                          ],
                          class: {
                            "is-active":
                              _vm.activeTab === _vm.itemCategoryTypes.REP,
                          },
                        },
                        [
                          _c(
                            "a",
                            {
                              on: {
                                click: function ($event) {
                                  return _vm.tabClicked(
                                    _vm.itemCategoryTypes.REP
                                  )
                                },
                              },
                            },
                            [
                              _c("span", [
                                _c(
                                  "span",
                                  { staticClass: "has-badge-child-offset2" },
                                  [_vm._v("Repair")]
                                ),
                                _vm.repairItems.length > 0
                                  ? _c("span", {
                                      staticClass:
                                        "has-badge-rounded has-badge-medium has-badge-info",
                                      attrs: {
                                        "data-badge": _vm.repairItems.length,
                                      },
                                    })
                                  : _vm._e(),
                              ]),
                            ]
                          ),
                        ]
                      ),
                      _c(
                        "li",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: _vm.showTab("PAINT"),
                              expression: "showTab('PAINT')",
                            },
                          ],
                          class: {
                            "is-active":
                              _vm.activeTab === _vm.itemCategoryTypes.PAINT,
                          },
                        },
                        [
                          _c(
                            "a",
                            {
                              on: {
                                click: function ($event) {
                                  return _vm.tabClicked(
                                    _vm.itemCategoryTypes.PAINT
                                  )
                                },
                              },
                            },
                            [
                              _c("span", [
                                _c(
                                  "span",
                                  { staticClass: "has-badge-child-offset2" },
                                  [_vm._v("Paint")]
                                ),
                                _vm.paintItems.length > 0
                                  ? _c("span", {
                                      staticClass:
                                        "has-badge-rounded has-badge-medium has-badge-info",
                                      attrs: {
                                        "data-badge": _vm.paintItems.length,
                                      },
                                    })
                                  : _vm._e(),
                              ]),
                            ]
                          ),
                        ]
                      ),
                      _c(
                        "li",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: _vm.showTab("FIBER"),
                              expression: "showTab('FIBER')",
                            },
                          ],
                          class: {
                            "is-active":
                              _vm.activeTab === _vm.itemCategoryTypes.FIBER,
                          },
                        },
                        [
                          _c(
                            "a",
                            {
                              on: {
                                click: function ($event) {
                                  return _vm.tabClicked(
                                    _vm.itemCategoryTypes.FIBER
                                  )
                                },
                              },
                            },
                            [
                              _c("span", [
                                _c(
                                  "span",
                                  { staticClass: "has-badge-child-offset2" },
                                  [_vm._v("Fiber")]
                                ),
                                _vm.fgItems.length > 0
                                  ? _c("span", {
                                      staticClass:
                                        "has-badge-rounded has-badge-medium has-badge-info",
                                      attrs: {
                                        "data-badge": _vm.fgItems.length,
                                      },
                                    })
                                  : _vm._e(),
                              ]),
                            ]
                          ),
                        ]
                      ),
                      _c(
                        "li",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: _vm.showTab("CRUSH"),
                              expression: "showTab('CRUSH')",
                            },
                          ],
                          class: {
                            "is-active":
                              _vm.activeTab === _vm.itemCategoryTypes.CRUSH,
                          },
                        },
                        [
                          _c(
                            "a",
                            {
                              on: {
                                click: function ($event) {
                                  return _vm.tabClicked(
                                    _vm.itemCategoryTypes.CRUSH
                                  )
                                },
                              },
                            },
                            [
                              _c("span", [
                                _c(
                                  "span",
                                  { staticClass: "has-badge-child-offset2" },
                                  [_vm._v("Crush")]
                                ),
                                _vm.crushItems.length > 0
                                  ? _c("span", {
                                      staticClass:
                                        "has-badge-rounded has-badge-medium has-badge-info",
                                      attrs: {
                                        "data-badge": _vm.crushItems.length,
                                      },
                                    })
                                  : _vm._e(),
                              ]),
                            ]
                          ),
                        ]
                      ),
                      _c(
                        "li",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: _vm.showTab("CD"),
                              expression: "showTab('CD')",
                            },
                          ],
                          class: {
                            "is-active":
                              _vm.activeTab === _vm.itemCategoryTypes.CD,
                          },
                        },
                        [
                          _c(
                            "a",
                            {
                              on: {
                                click: function ($event) {
                                  return _vm.tabClicked(
                                    _vm.itemCategoryTypes.CD
                                  )
                                },
                              },
                            },
                            [
                              _c("span", [
                                _c(
                                  "span",
                                  { staticClass: "has-badge-child-offset2" },
                                  [_vm._v("C&D")]
                                ),
                                _vm.cdItems.length > 0
                                  ? _c("span", {
                                      staticClass:
                                        "has-badge-rounded has-badge-medium has-badge-info",
                                      attrs: {
                                        "data-badge": _vm.cdItems.length,
                                      },
                                    })
                                  : _vm._e(),
                              ]),
                            ]
                          ),
                        ]
                      ),
                      _c(
                        "li",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: _vm.showTab("MECH"),
                              expression: "showTab('MECH')",
                            },
                          ],
                          class: {
                            "is-active":
                              _vm.activeTab === _vm.itemCategoryTypes.MECH,
                          },
                        },
                        [
                          _c(
                            "a",
                            {
                              on: {
                                click: function ($event) {
                                  return _vm.tabClicked(
                                    _vm.itemCategoryTypes.MECH
                                  )
                                },
                              },
                            },
                            [
                              _c("span", [
                                _c(
                                  "span",
                                  { staticClass: "has-badge-child-offset2" },
                                  [_vm._v("Mech")]
                                ),
                                _vm.mechItems.length > 0
                                  ? _c("span", {
                                      staticClass:
                                        "has-badge-rounded has-badge-medium has-badge-info",
                                      attrs: {
                                        "data-badge": _vm.mechItems.length,
                                      },
                                    })
                                  : _vm._e(),
                              ]),
                            ]
                          ),
                        ]
                      ),
                      _c(
                        "li",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: _vm.showTab("PART"),
                              expression: "showTab('PART')",
                            },
                          ],
                          class: {
                            "is-active":
                              _vm.activeTab === _vm.itemCategoryTypes.PART,
                          },
                        },
                        [
                          _c(
                            "a",
                            {
                              on: {
                                click: function ($event) {
                                  return _vm.tabClicked(
                                    _vm.itemCategoryTypes.PART
                                  )
                                },
                              },
                            },
                            [
                              _c("span", [
                                _c(
                                  "span",
                                  { staticClass: "has-badge-child-offset2" },
                                  [_vm._v("Part")]
                                ),
                                _vm.partItems.length > 0
                                  ? _c("span", {
                                      staticClass:
                                        "has-badge-rounded has-badge-medium has-badge-info",
                                      attrs: {
                                        "data-badge": _vm.partItems.length,
                                      },
                                    })
                                  : _vm._e(),
                              ]),
                            ]
                          ),
                        ]
                      ),
                      _c(
                        "li",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: _vm.showTab("OPG"),
                              expression: "showTab('OPG')",
                            },
                          ],
                          class: {
                            "is-active":
                              _vm.activeTab === _vm.itemCategoryTypes.OPG,
                          },
                        },
                        [
                          _c(
                            "a",
                            {
                              on: {
                                click: function ($event) {
                                  return _vm.tabClicked(
                                    _vm.itemCategoryTypes.OPG
                                  )
                                },
                              },
                            },
                            [
                              _c("span", [
                                _c(
                                  "span",
                                  { staticClass: "has-badge-child-offset2" },
                                  [_vm._v("OPG")]
                                ),
                                _vm.opgItems.length > 0
                                  ? _c("span", {
                                      staticClass:
                                        "has-badge-rounded has-badge-medium has-badge-info",
                                      attrs: {
                                        "data-badge": _vm.opgItems.length,
                                      },
                                    })
                                  : _vm._e(),
                              ]),
                            ]
                          ),
                        ]
                      ),
                      _c(
                        "li",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: _vm.showTab("MISC"),
                              expression: "showTab('MISC')",
                            },
                          ],
                          class: {
                            "is-active":
                              _vm.activeTab === _vm.itemCategoryTypes.MISC,
                          },
                        },
                        [
                          _c(
                            "a",
                            {
                              on: {
                                click: function ($event) {
                                  return _vm.tabClicked(
                                    _vm.itemCategoryTypes.MISC
                                  )
                                },
                              },
                            },
                            [
                              _c("span", [
                                _c(
                                  "span",
                                  { staticClass: "has-badge-child-offset2" },
                                  [_vm._v("Misc")]
                                ),
                                _vm.miscItems.length > 0
                                  ? _c("span", {
                                      staticClass:
                                        "has-badge-rounded has-badge-medium has-badge-info",
                                      attrs: {
                                        "data-badge": _vm.miscItems.length,
                                      },
                                    })
                                  : _vm._e(),
                              ]),
                            ]
                          ),
                        ]
                      ),
                      _c(
                        "li",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: _vm.showTab("SUBL"),
                              expression: "showTab('SUBL')",
                            },
                          ],
                          class: {
                            "is-active":
                              _vm.activeTab === _vm.itemCategoryTypes.SUBL,
                          },
                        },
                        [
                          _c(
                            "a",
                            {
                              on: {
                                click: function ($event) {
                                  return _vm.tabClicked(
                                    _vm.itemCategoryTypes.SUBL
                                  )
                                },
                              },
                            },
                            [
                              _c("span", [
                                _c(
                                  "span",
                                  { staticClass: "has-badge-child-offset2" },
                                  [_vm._v("Sublet")]
                                ),
                                _vm.subletItems.length > 0
                                  ? _c("span", {
                                      staticClass:
                                        "has-badge-rounded has-badge-medium has-badge-info",
                                      attrs: {
                                        "data-badge": _vm.subletItems.length,
                                      },
                                    })
                                  : _vm._e(),
                              ]),
                            ]
                          ),
                        ]
                      ),
                    ]),
                    _vm.isEditableToAuthorise &&
                    ((_vm.lastQuoteAssessment?.subQuoteNo === 0 &&
                      _vm.requestAuthorityPending) ||
                      _vm.lastQuoteAssessment === null)
                      ? _c(
                          "button",
                          {
                            staticClass:
                              "button is-primary tooltip is-tooltip-topright",
                            attrs: { "data-tooltip": "Edit rates" },
                            on: { click: _vm.openEditRatesModal },
                          },
                          [_vm._m(9), _c("span", [_vm._v("Edit Rates")])]
                        )
                      : _vm._e(),
                  ]),
                  _vm.isLabour
                    ? _c("authorise-labour-old", {
                        attrs: {
                          value: _vm.innerValue,
                          vehicle: _vm.innerVehicle,
                          "next-line-number": _vm.innerValue.lines,
                          "original-value": _vm.value,
                          editable: _vm.isEditable,
                          "item-type": _vm.activeTab,
                          "items-list": [
                            ..._vm.rrItems,
                            ..._vm.rwaItems,
                            ..._vm.repairItems,
                            ..._vm.paintItems,
                          ],
                        },
                      })
                    : _vm._e(),
                  _vm.isOtherLabour
                    ? _c("authorise-other-labour-old", {
                        attrs: {
                          value: _vm.innerValue,
                          vehicle: _vm.innerVehicle,
                          "next-line-number": _vm.innerValue.lines,
                          "original-value": _vm.value,
                          editable: _vm.isEditable,
                          "item-type": _vm.activeTab,
                          "items-list": [
                            ..._vm.mechItems,
                            ..._vm.cdItems,
                            ..._vm.crushItems,
                            ..._vm.fgItems,
                          ],
                        },
                      })
                    : _vm._e(),
                  _vm.isPart
                    ? _c("authorise-part-old", {
                        attrs: {
                          value: _vm.innerValue,
                          vehicle: _vm.innerVehicle,
                          "next-line-number": _vm.innerValue.lines,
                          "original-value": _vm.value,
                          editable: _vm.isEditable,
                          "item-type": _vm.activeTab,
                          "items-list": [..._vm.partItems],
                        },
                      })
                    : _vm._e(),
                  _vm.isOpg
                    ? _c("authorise-opg-old", {
                        attrs: {
                          value: _vm.innerValue,
                          vehicle: _vm.innerVehicle,
                          "next-line-number": _vm.innerValue.lines,
                          "original-value": _vm.value,
                          editable: _vm.isEditable,
                          "item-type": _vm.activeTab,
                          "items-list": [..._vm.opgItems],
                        },
                      })
                    : _vm._e(),
                  _vm.isMisc
                    ? _c("authorise-misc-old", {
                        attrs: {
                          value: _vm.innerValue,
                          vehicle: _vm.innerVehicle,
                          "next-line-number": _vm.innerValue.lines,
                          "original-value": _vm.value,
                          editable: _vm.isEditable,
                          "item-type": _vm.activeTab,
                          "items-list": [..._vm.miscItems],
                        },
                      })
                    : _vm._e(),
                  _vm.isSublet
                    ? _c("authorise-sublet-old", {
                        attrs: {
                          value: _vm.innerValue,
                          vehicle: _vm.innerVehicle,
                          "next-line-number": _vm.innerValue.lines,
                          "original-value": _vm.value,
                          editable: _vm.isEditable,
                          "item-type": _vm.activeTab,
                          "items-list": [..._vm.subletItems],
                        },
                      })
                    : _vm._e(),
                ],
                1
              ),
            ]),
          ]),
        ]),
      ]),
      _vm.isAuthoriseModalVisible
        ? _c("authorise-modal", {
            attrs: {
              "show-icon": true,
              active: _vm.isAuthoriseModalVisible,
              "quote-values": _vm.innerValue,
              "vehicle-values": _vm.innerVehicle,
              "selected-items": _vm.selectedItems,
              "total-selected-items": _vm.totalSelectedItems,
            },
            on: {
              "update:active": function ($event) {
                _vm.isAuthoriseModalVisible = $event
              },
              authorise: function ($event) {
                return _vm.authorise()
              },
              close: function ($event) {
                _vm.isAuthoriseModalVisible = false
              },
            },
          })
        : _vm._e(),
      _vm.isEditRateModalVisible
        ? _c("edit-rates-modal", {
            attrs: {
              "show-icon": true,
              active: _vm.isEditRateModalVisible,
              "quote-values": _vm.innerValue,
              "vehicle-values": _vm.innerVehicle,
              "selected-items": _vm.selectedItems,
              "total-selected-items": _vm.totalSelectedItems,
            },
            on: {
              "update:active": function ($event) {
                _vm.isEditRateModalVisible = $event
              },
              "apply-rates": function ($event) {
                return _vm.applyRates()
              },
              close: function ($event) {
                _vm.isEditRateModalVisible = false
              },
            },
          })
        : _vm._e(),
      _vm.isRequestModalVisible
        ? _c(
            "confirm-modal",
            {
              attrs: {
                active: _vm.isRequestModalVisible,
                "ok-text": "Authorise",
                "ok-class": "is-success",
                "cancel-text": "Cancel",
              },
              on: {
                "update:active": function ($event) {
                  _vm.isRequestModalVisible = $event
                },
                ok: function ($event) {
                  return _vm.authorise()
                },
                cancel: function ($event) {
                  _vm.isRequestModalVisible = false
                },
              },
            },
            [
              _c("p", { attrs: { slot: "text-title" }, slot: "text-title" }, [
                _vm._v("Confirm to request"),
              ]),
              _c(
                "p",
                { attrs: { slot: "text-content" }, slot: "text-content" },
                [
                  _vm._v(
                    " Are you sure you want to request the selected items? "
                  ),
                ]
              ),
            ]
          )
        : _vm._e(),
      _vm.isRevertConfirmModalActive
        ? _c(
            "confirm-modal",
            {
              attrs: {
                active: _vm.isRevertConfirmModalActive,
                "ok-text": "Revert to Authority",
                "ok-class": "is-success",
                "cancel-text": "No",
              },
              on: {
                "update:active": function ($event) {
                  _vm.isRevertConfirmModalActive = $event
                },
                ok: function ($event) {
                  return _vm.revertToAuthority(true)
                },
                cancel: function ($event) {
                  _vm.isRevertConfirmModalActive = false
                },
              },
            },
            [
              _c("p", { attrs: { slot: "text-title" }, slot: "text-title" }, [
                _vm._v("Revert to Authority"),
              ]),
              _c(
                "p",
                { attrs: { slot: "text-content" }, slot: "text-content" },
                [
                  _vm._v(
                    " Are you sure you want to revert to the last authority? All changes since the last authority will be lost. "
                  ),
                ]
              ),
            ]
          )
        : _vm._e(),
      _vm.isCancelAuthorityConfirmModalActive
        ? _c(
            "confirm-modal",
            {
              attrs: {
                active: _vm.isCancelAuthorityConfirmModalActive,
                "show-close": true,
                "cancel-text": "Discard Changes",
                "cancel-class": "is-warning",
                "ok-class": "is-success",
                "ok-text": "Merge Changes",
                "close-text": "Close",
              },
              on: {
                "update:active": function ($event) {
                  _vm.isCancelAuthorityConfirmModalActive = $event
                },
                ok: function ($event) {
                  return _vm.cancelAuthority(true)
                },
                cancel: function ($event) {
                  return _vm.cancelAuthority(false)
                },
                close: function ($event) {
                  _vm.isCancelAuthorityConfirmModalActive = false
                },
              },
            },
            [
              _c("p", { attrs: { slot: "text-title" }, slot: "text-title" }, [
                _vm._v("Cancel last Authority"),
              ]),
              _c(
                "p",
                { attrs: { slot: "text-content" }, slot: "text-content" },
                [
                  _vm._v(
                    " Do you want the changes made in the last authority to be merged or discarded? "
                  ),
                ]
              ),
            ]
          )
        : _vm._e(),
      _vm.isCancelRequestConfirmModalActive
        ? _c(
            "confirm-modal",
            {
              attrs: {
                active: _vm.isCancelRequestConfirmModalActive,
                "show-close": true,
                "cancel-text": "Discard Changes",
                "cancel-class": "is-warning",
                "ok-class": "is-success",
                "ok-text": "Merge Changes",
                "close-text": "Close",
              },
              on: {
                "update:active": function ($event) {
                  _vm.isCancelRequestConfirmModalActive = $event
                },
                ok: function ($event) {
                  return _vm.cancelRequest(true)
                },
                cancel: function ($event) {
                  return _vm.cancelRequest(false)
                },
                close: function ($event) {
                  _vm.isCancelRequestConfirmModalActive = false
                },
              },
            },
            [
              _c("p", { attrs: { slot: "text-title" }, slot: "text-title" }, [
                _vm._v("Cancel last Request"),
              ]),
              _c(
                "p",
                { attrs: { slot: "text-content" }, slot: "text-content" },
                [
                  _vm._v(
                    " Do you want the changes made in the last request for authority to be merged or discarded? "
                  ),
                ]
              ),
            ]
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "state p-primary" }, [
      _c("i", { staticClass: "icon mdi mdi-check" }),
      _c("label", { staticClass: "has-text-info has-text-weight-semibold" }, [
        _vm._v("Select All Items"),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("span", { staticClass: "icon" }, [
      _c("i", { staticClass: "mdi mdi-close" }),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("span", { staticClass: "icon" }, [
      _c("i", { staticClass: "mdi mdi-close" }),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("span", { staticClass: "icon" }, [
      _c("i", { staticClass: "mdi mdi-undo" }),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("span", { staticClass: "icon" }, [
      _c("i", { staticClass: "mdi mdi-close" }),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("span", { staticClass: "icon" }, [
      _c("i", { staticClass: "mdi mdi-file-send" }),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("span", { staticClass: "icon" }, [
      _c("i", { staticClass: "mdi mdi-playlist-check" }),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("span", { staticClass: "icon" }, [
      _c("i", { staticClass: "mdi mdi-playlist-check" }),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("span", { staticClass: "icon" }, [
      _c("i", { staticClass: "mdi mdi-file-send" }),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("span", { staticClass: "icon" }, [
      _c("i", { staticClass: "mdi mdi-pencil" }),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }